// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__30UDK","vLegacy":"SelectSecondary_vLegacy__ujOQ4","error":"SelectSecondary_error__1s5FY","disabled":"SelectSecondary_disabled__3OiEx"};